import adminApi from "./../../api/src/ApiClient";

export default {
  namespaced: true,

  state: {
    orders: [],
    count: 0
  },

  mutations: {
    orders(state, response) {
      state.orders = response;
    },
    ordersCount(state, response) {
      state.count = Number(response.count);
    }
  },

  actions: {
    async orderList({ commit, state }, params) {
      let result = await adminApi.get(
        "api/orders?limit=" + params.limit + "&offset=" + params.offset
      );
      commit("orders", result);
    },

    async stats({}) {
      return await adminApi.get("api/orders/stats");
    },

    async ordersCount({ commit, state }, params) {
      let result = await adminApi.get("api/orders/count");
      commit("ordersCount", result);
    },

    async create({ commit, state }, params) {
      return await adminApi.post("api/order", params);
    },

    async getOrder({}, id) {
      return await adminApi.get("api/order/" + id);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/order/src/OrderStore.js